const URL = {
  UPLOAD_ATTACHMENT: 'attachment',
  GET_ATTACHMENT: 'attachment',
  DELETE_ATTACHMENT: 'attachment/{attachmentId}',
  GENERATE_OUTLINE: 'outline',
  GENERATE_CONTENT: 'outline/generate-content',
  UPDATE_OUTLINE: 'outline/{outlineId}',
  CHECK_ATTACHMENT_STATUS: 'attachment/{attachmentId}',
  GET_DOCUMENT_HEADERS: 'outline/{outlineId}/attachments/titles',
  GET_ATTACHMENT_TITLES: 'attachment/titles',
}

export default URL
